export enum ArrowClass {
  None = "no-arrow",
  Left = "left-arrow",
  TopRight = "top-right-arrow",
}
